import { defineComponent as n, computed as o, openBlock as a, createElementBlock as i, createElementVNode as e, toDisplayString as r, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "df9bf0c2-a2fa-47df-a9c2-2234a1ad68f4" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#df9bf0c2-a2fa-47df-a9c2-2234a1ad68f4)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M0 0h512v167H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 345h512v167H0z"
}, null, -1), w = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m332.5 122.4-31.2-14.7 16.6-30.3-34 6.5-4.3-34.3L256 75l-23.6-25.3L228 84l-34-6.5 16.7 30.3-31.3 14.7z"
}, null, -1), x = { fill: "none" }, y = ["r"], N = /* @__PURE__ */ n({
  __name: "mw",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), d = o(() => 256 + t.strokeWidth / 2);
    return (z, W) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (a(), i("title", p, r(t.flagName), 1)) : f("", !0),
        k,
        v,
        g,
        w
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=mw-1f2ca459.js.map
